"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatsAppGroupDetail = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const component_1 = require("@front/components/site-menu/component");
const WhatsAppAgentService_1 = __importStar(require("@front/services/WhatsAppAgentService"));
const ClipboardService_1 = __importStar(require("@front/services/ClipboardService"));
const uuid_1 = require("uuid");
//@ts-ignore                
let rwsTemplate = T.html `<div ${(0, fast_element_1.ref)('mainContainer')} class="whatsapp-group-detail container-fluid">
    <div class="comms-group-list-header mb-4">
        <h1>
            <i class="simple-icon-speech mr-2" style="color: #25d366;"></i>${x => x.group ? x.group.groupName : 'whatsapp.groups.loading'.t()}
            ${(0, fast_element_1.when)(x => { var _a; return (_a = x.group) === null || _a === void 0 ? void 0 : _a.communicationType; }, (0, fast_element_1.html) `
                <span class="badge rounded-pill ml-2" style="font-size: 0.7rem; vertical-align: middle; background-color: ${x => { var _a; return ((_a = x.group) === null || _a === void 0 ? void 0 : _a.communicationType) === 'TELE' ? '#0088cc' : '#25d366'; }}; color: #fff; letter-spacing: 0.02em;">${x => { var _a; return ((_a = x.group) === null || _a === void 0 ? void 0 : _a.communicationType) === 'TELE' ? 'whatsapp.groups.communicationType.tele'.t() : 'whatsapp.groups.communicationType.wa'.t(); }}</span>
            `)}
        </h1>
        ${(0, fast_element_1.when)(x => !x.remote, (0, fast_element_1.html) `<div class="comms-group-list-actions text-zero top-right-button-container">
            <button @click="${x => x.goBack()}" type="button"
              class="top-right-button mr-1 btn btn-primary btn-lg">${'whatsapp.groups.back'.t()}</button>
            <button @click="${x => x.copyGroupViewUrl()}" type="button"
              class="top-right-button mr-1 btn btn-outline-primary btn-lg"
              title="${'whatsapp.groups.copyUrl.title'.t()}">
              <i class="simple-icon-link"></i>
              ${x => x.copiedUrl ? 'whatsapp.groups.copyUrl.copied'.t() : 'whatsapp.groups.copyUrl.label'.t()}
            </button>
        </div>`)}
    </div>

    ${(0, fast_element_1.when)(x => x.agentChecking && !x.loading, (0, fast_element_1.html) `
        <div class="alert alert-warning d-flex align-items-center mb-3" role="alert">
            <span class="spinner-border spinner-border-sm mr-2"></span>
            ${'whatsapp.groups.agentChecking'.t()}
        </div>
    `)}

    ${(0, fast_element_1.when)(x => !x.agentChecking && !x.agentActive && !x.loading, (0, fast_element_1.html) `
        <div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
            <i class="simple-icon-ban mr-2"></i>
            ${'whatsapp.groups.agentOffline'.t()}
        </div>
    `)}

    ${(0, fast_element_1.when)(x => !x.loading && !!x.group, (0, fast_element_1.html) `
        <comms-stats-alerts mode="groups" :trackLogs="${x => x.trackLogs}" :items="${x => x.group ? [x.group] : []}"></comms-stats-alerts>
    `)}

    ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
        <app-loader></app-loader>
    `)}

    ${(0, fast_element_1.when)(x => !x.loading && !x.group, (0, fast_element_1.html) `
        <div class="alert alert-danger">${'whatsapp.groups.notFound'.t()}</div>
    `)}

    ${(0, fast_element_1.when)(x => !x.loading && !!x.group, (0, fast_element_1.html) `
        <div class="row">

            
            <div class="col-lg-6">

                
                <div class="comms-group-list-contact-info card mb-4">
                    <div class="card-header bg-light py-3">
                        <h5 class="card-title mb-0"><i class="simple-icon-info mr-2" style="color: #17a2b8;"></i>${'whatsapp.groups.info'.t()}</h5>
                    </div>
                    <div class="card-body">
                        <div class="row g-2 mb-3">
                            <div class="col-12">
                                <div class="p-3 card mb-2" style="background: #f0f9ff; border: 1px solid #bee3f8;">
                                    <small class="text-muted d-block mb-1">${'whatsapp.groups.name'.t()}</small>
                                    <strong style="font-size: 1.05rem; color: #1a1a2e;">${x => { var _a; return (_a = x.group) === null || _a === void 0 ? void 0 : _a.groupName; }}</strong>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="p-3 card h-100" style="background: #f8f9fa; border: 1px solid #e2e8f0;">
                                    <small class="text-muted d-block mb-1">${x => { var _a; return ((_a = x.group) === null || _a === void 0 ? void 0 : _a.communicationType) === 'TELE' ? 'whatsapp.groups.teleId'.t() : 'whatsapp.groups.waId'.t(); }}</small>
                                    <span class="small" style="font-family: monospace; color: #555; word-break: break-all;">${x => { var _a; return (_a = x.group) === null || _a === void 0 ? void 0 : _a.groupWaId; }}</span>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="p-3 card h-100" style="background: #f0fff4; border: 1px solid #9ae6b4;">
                                    <small class="text-muted d-block mb-1">${'whatsapp.groups.phone'.t()}</small>
                                    <strong style="color: #276749;">${x => { var _a; return (_a = x.group) === null || _a === void 0 ? void 0 : _a.phoneNumber; }}</strong>
                                </div>
                            </div>
                        </div>
                        <part-switch label="whatsapp.groups.tracking" :value="${x => { var _a; return (_a = x.group) === null || _a === void 0 ? void 0 : _a.tracking; }}" :disabled="${x => x.saving}" @click="${(x, c) => x.toggleTracking(c.event)}"></part-switch>
                        ${(0, fast_element_1.when)(x => { var _a, _b; return ((_a = x.group) === null || _a === void 0 ? void 0 : _a.isOwned) && ((_b = x.group) === null || _b === void 0 ? void 0 : _b.tracking); }, (0, fast_element_1.html) `
                            <div class="mt-3">
                                <part-textarea class="form-part" label="${'whatsapp.groups.pinMessage.label'.t()}"
                                    :value="${x => x.editPinMessage}" name="pinMessage" rows="4"
                                    placeholder="${'whatsapp.groups.pinMessage.placeholder'.t()}"
                                    @change="${(x, c) => x.handlePinMessageInput(c.event)}"
                                    ?disabled="${x => x.saving}"></part-textarea>
                                <div class="form-text">${'whatsapp.groups.pinMessage.hint'.t()}</div>
                            </div>
                            <div class="mt-2">
                                <part-switch label="whatsapp.groups.pinReminder.label" :value="${x => x.editPinReminderEnabled}" :disabled="${x => x.saving}" @click="${(x, c) => x.handlePinReminderToggle(c.event)}"></part-switch>
                                ${(0, fast_element_1.when)(x => x.editPinReminderEnabled, (0, fast_element_1.html) `
                                <div class="mt-2">
                                    <part-input class="form-part" label="${'whatsapp.groups.pinReminder.intervalLabel'.t()}"
                                        :value="${x => x.editPinReminderIntervalHours}" name="pinReminderIntervalHours" type="number" min="1"
                                        @change="${(x, c) => x.handlePinReminderIntervalInput(c.event)}"
                                        ?disabled="${x => x.saving}"></part-input>
                                </div>
                                `)}
                                <div class="form-text">${'whatsapp.groups.pinReminder.hint'.t()}</div>
                            </div>
                        `)}
                        ${(0, fast_element_1.when)(x => { var _a; return (_a = x.group) === null || _a === void 0 ? void 0 : _a.isOwned; }, (0, fast_element_1.html) `
                            ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.group) === null || _a === void 0 ? void 0 : _a.communicationType) === 'WA'; }, (0, fast_element_1.html) `
                            <div class="mt-2">
                                <part-switch label="whatsapp.groups.announce.label" :value="${x => !x.announceMode}" :disabled="${x => x.announceSaving}" @click="${(x, c) => x.toggleAnnounce(c.event)}"></part-switch>
                                ${(0, fast_element_1.when)(x => x.announceSaving, (0, fast_element_1.html) `<app-loader block="true" width="12px" height="12px"></app-loader>`)}
                            </div>
                            <p class="text-muted small mt-1">${'whatsapp.groups.announce.hint'.t()}</p>
                            `)}
                            ${(0, fast_element_1.when)(x => !x.remote, (0, fast_element_1.html) `<div class="d-flex align-items-center gap-2 mt-2 flex-wrap">
                                <part-switch label="whatsapp.groups.remoteAccess.label" :value="${x => x.editRemoteAccess}" :disabled="${x => x.saving}" @click="${(x, c) => x.handleRemoteAccessChange(c.event)}"></part-switch>
                                ${(0, fast_element_1.when)(x => x.editRemoteAccess, (0, fast_element_1.html) `
                                    <input type="text" class="ml-2 form-control form-control-sm" style="max-width: 200px;"
                                           placeholder="${'whatsapp.groups.accessPassword.label'.t()}"
                                           :value="${x => x.editAccessPassword}"
                                           @input="${(x, c) => x.handleAccessPasswordInput(c.event)}"
                                           autocomplete="new-password"
                                           ?disabled="${x => x.saving}" />
                                `)}
                                <button type="button" class="ml-2 btn btn-outline-primary btn-sm"
                                        @click="${x => x.saveSecurity()}"
                                        ?disabled="${x => x.saving}">
                                    ${(0, fast_element_1.when)(x => x.saving, (0, fast_element_1.html) `<app-loader block="true" width="12px" height="12px"></app-loader>`)}
                                    ${'whatsapp.groups.security.save'.t()}
                                </button>
                            </div>`)}
                        `)}
                    </div>
                </div>

                
                <div class="comms-group-list-members card mb-4">
                    <div class="card-header bg-light d-flex justify-content-between align-items-center py-3">
                        <h5 class="card-title mb-0"><i class="simple-icon-people mr-2" style="color: #ffc107;"></i>${'whatsapp.groups.members.title'.t()}</h5>
                        <button type="button" class="btn btn-outline-secondary btn-sm" @click="${x => x.syncMembers()}" ?disabled="${x => x.membersLoading || !x.agentActive}">
                            ${(0, fast_element_1.when)(x => x.membersLoading, (0, fast_element_1.html) `<app-loader block="true" width="12px" height="12px"></app-loader>`)}
                            ${(0, fast_element_1.when)(x => !x.membersLoading, (0, fast_element_1.html) `<i class="simple-icon-refresh mr-1"></i>`)}
                            ${'whatsapp.groups.members.sync'.t()}
                        </button>
                    </div>
                    <div class="card-body p-0">
                        ${(0, fast_element_1.when)(x => x.membersLoading && x.members.length === 0, (0, fast_element_1.html) `
                            <div class="text-center p-3"><app-loader block="true" width="15px" height="15px"></app-loader></div>
                        `)}
                        ${(0, fast_element_1.when)(x => !x.membersLoading && x.members.length === 0, (0, fast_element_1.html) `
                            <p class="text-muted text-center p-4">${'whatsapp.groups.members.empty'.t()}</p>
                        `)}
                        ${(0, fast_element_1.when)(x => x.members.length > 0, (0, fast_element_1.html) `
                            <div class="table-responsive">
                            <table id="members-list" class="table table-striped table-hover mb-0 small">
                                <thead>
                                    <tr>
                                        <th>${'whatsapp.groups.members.name'.t()}</th>
                                        <th>${x => { var _a; return ((_a = x.group) === null || _a === void 0 ? void 0 : _a.communicationType) === 'TELE' ? 'whatsapp.groups.members.username'.t() : 'whatsapp.groups.members.phone'.t(); }}</th>
                                        <th>${'whatsapp.groups.members.role'.t()}</th>
                                        <th>${'whatsapp.groups.members.feedBotData'.t()}</th>
                                        <th>${'whatsapp.groups.members.allowBotUsage'.t()}</th>
                                        <th class="text-end" style="width: 50px;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${(0, fast_element_1.repeat)(x => x.members, (0, fast_element_1.html) `
                                        <tr class="member-row" data-member="${x => x.displayName || x.memberPhone}">
                                            <td>${x => x.displayName || '—'}</td>
                                            <td class="small text-muted">${x => x.memberPhone || '—'}</td>
                                            <td>
                                                ${(0, fast_element_1.when)(x => !!x.isSuperAdmin, (0, fast_element_1.html) `<span class="badge bg-danger">${'whatsapp.groups.members.superAdmin'.t()}</span>`)}
                                                ${(0, fast_element_1.when)(x => !!x.isAdmin && !x.isSuperAdmin, (0, fast_element_1.html) `<span class="badge bg-warning text-dark">${'whatsapp.groups.members.admin'.t()}</span>`)}
                                                ${(0, fast_element_1.when)(x => !x.isAdmin && !x.isSuperAdmin, (0, fast_element_1.html) `<span class="badge bg-secondary">${'whatsapp.groups.members.member'.t()}</span>`)}
                                            </td>
                                            <td>
                                                <part-switch :value="${x => x.feedBotData}" name="feedBotData" @click="${(x, c) => c.parent.toggleMemberBotSetting(x.id, 'feedBotData', !x.feedBotData)}" dontEmit="true"></part-switch>
                                            </td>
                                            <td>
                                                <part-switch :value="${x => x.allowBotUsage}" name="allowBotUsage" @click="${(x, c) => c.parent.toggleMemberBotSetting(x.id, 'allowBotUsage', !x.allowBotUsage)}" dontEmit="true"></part-switch>
                                            </td>
                                            <td class="text-end">
                                                ${(0, fast_element_1.when)(x => !x.isSuperAdmin, (0, fast_element_1.html) `
                                                    ${(0, fast_element_1.when)((x, c) => { var _a; return (_a = c.parent.group) === null || _a === void 0 ? void 0 : _a.isOwned; }, (0, fast_element_1.html) `
                                                        <div class="d-flex justify-content-end align-items-center member-tools">
                                                            ${(0, fast_element_1.when)(x => !x.isAdmin, (0, fast_element_1.html) `
                                                                <rws-tooltip text="${'whatsapp.groups.members.promote'.t()}" side="left">
                                                                    <button type="button" class="btn btn-outline-warning btn-sm icon-btn"
                                                                            ?disabled="${(x, c) => !!c.parent.promotingMemberId || !c.parent.agentActive}"
                                                                            @click="${(x, c) => c.parent.promoteMember(x.memberId)}">
                                                                        ${(0, fast_element_1.when)((x, c) => c.parent.promotingMemberId === x.memberId, (0, fast_element_1.html) `<app-loader block="true" width="12px" height="12px"></app-loader>`)}
                                                                        ${(0, fast_element_1.when)((x, c) => c.parent.promotingMemberId !== x.memberId, (0, fast_element_1.html) `<i class="simple-icon-star"></i>`)}
                                                                    </button>
                                                                </rws-tooltip>
                                                            `)}
                                                            <rws-tooltip text="${'whatsapp.groups.members.remove'.t()}" side="left">
                                                                <button type="button" class="btn btn-outline-danger btn-sm icon-btn"
                                                                        ?disabled="${(x, c) => !!c.parent.removingMemberId || !c.parent.agentActive}"
                                                                        @click="${(x, c) => c.parent.removeMember(x.memberId)}">
                                                                    ${(0, fast_element_1.when)((x, c) => c.parent.removingMemberId === x.memberId, (0, fast_element_1.html) `<app-loader block="true" width="12px" height="12px"></app-loader>`)}
                                                                    ${(0, fast_element_1.when)((x, c) => c.parent.removingMemberId !== x.memberId, (0, fast_element_1.html) `<i class="simple-icon-trash"></i>`)}
                                                                </button>
                                                            </rws-tooltip>
                                                        </div>
                                                    `)}
                                                `)}
                                            </td>
                                        </tr>
                                    `)}
                                </tbody>
                            </table>
                            </div>
                        `)}
                    </div>
                </div>

                
                ${(0, fast_element_1.when)(x => { var _a; return (_a = x.group) === null || _a === void 0 ? void 0 : _a.isOwned; }, (0, fast_element_1.html) `
                <div class="comms-group-list-add-participants card mb-4">
                    <div class="card-header bg-light py-3">
                        <h5 class="card-title mb-0"><i class="simple-icon-user-follow mr-2" style="color: #28a745;"></i>${'whatsapp.groups.addParticipants.title'.t()}</h5>
                    </div>
                    <div class="card-body">
                        <div class="d-flex gap-2 mb-2">
                            <input type="text" class="form-control"
                                   placeholder="${'whatsapp.groups.addParticipants.phonePlaceholder'.t()}"
                                   :value="${x => x.newParticipantPhone}"
                                   @input="${(x, c) => x.handleNewParticipantPhoneInput(c.event)}"
                                   ?disabled="${x => x.addingParticipants}" />
                            <button type="button" class="ml-2 btn btn-outline-primary flex-shrink-0"
                                @click="${x => x.addParticipantPhone()}"
                                ?disabled="${x => x.addingParticipants}">
                                <i class="simple-icon-plus mr-1"></i>${'whatsapp.groups.addParticipants.addPhone'.t()}
                            </button>
                        </div>
                        ${(0, fast_element_1.when)(x => x.participantPhones.length === 0, (0, fast_element_1.html) `
                            <p class="text-muted small mb-0">${'whatsapp.groups.addParticipants.noPhonesYet'.t()}</p>
                        `)}
                        ${(0, fast_element_1.when)(x => x.participantPhones.length > 0, (0, fast_element_1.html) `
                            <ul class="list-group mb-3">
                                ${(0, fast_element_1.repeat)(x => x.participantPhones, (0, fast_element_1.html) `
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span>${p => p.phoneNumber}</span>
                                        <button type="button" class="btn btn-sm btn-danger"
                                                @click="${(p, c) => c.parent.removeParticipantPhone(p)}"
                                                ?disabled="${(p, c) => c.parent.addingParticipants}">
                                            <i class="simple-icon-trash"></i>
                                        </button>
                                    </li>
                                `)}
                            </ul>
                            <button type="button" class="btn btn-primary"
                                    @click="${x => x.addParticipants()}"
                                    ?disabled="${x => x.addingParticipants || !x.agentActive}">
                                ${(0, fast_element_1.when)(x => x.addingParticipants, (0, fast_element_1.html) `<app-loader block="true" width="15px" height="15px"></app-loader>`)}
                                ${(0, fast_element_1.when)(x => !x.addingParticipants, (0, fast_element_1.html) `${'whatsapp.groups.addParticipants.submit'.t()}`)}
                            </button>
                        `)}
                    </div>
                </div>
                `)}

                
                <div class="comms-group-list-bot-settings card mb-4">
                    <div class="card-header bg-light py-3">
                        <h5 class="card-title mb-0"><i class="simple-icon-settings mr-2" style="color: #6c757d;"></i>${'whatsapp.groups.botSettings'.t()}</h5>
                    </div>
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="form-label"><i class="simple-icon-pencil mr-1"></i>${'whatsapp.groups.botInstruction'.t()}</label>
                            <textarea class="form-control" rows="4"
                                      placeholder="${'whatsapp.groups.botInstructionPlaceholder'.t()}"
                                      :value="${x => x.editBotInstruction}"
                                      @input="${(x, c) => x.handleBotInstructionInput(c.event)}"
                                      ?disabled="${x => x.saving}"></textarea>
                        </div>
                        <button type="button" class="btn btn-primary"
                                @click="${x => x.saveSettings()}"
                                ?disabled="${x => x.saving}">
                            ${(0, fast_element_1.when)(x => x.saving, (0, fast_element_1.html) `<app-loader block="true" width="15px" height="15px"></app-loader>`)}
                            <i class="simple-icon-check mr-1"></i>${'whatsapp.groups.saveSettings'.t()}
                        </button>
                    </div>
                </div>

            </div>

            
            <div class="col-lg-6">

                ${(0, fast_element_1.when)(x => { var _a; return (_a = x.group) === null || _a === void 0 ? void 0 : _a.tracking; }, (0, fast_element_1.html) `
                
                <comms-messages
                    mode="group"
                    :groupId="${x => { var _a; return ((_a = x.group) === null || _a === void 0 ? void 0 : _a.id) || ''; }}"
                    :groupWaId="${x => { var _a; return ((_a = x.group) === null || _a === void 0 ? void 0 : _a.groupWaId) || ''; }}"
                    :phoneNumber="${x => { var _a; return ((_a = x.group) === null || _a === void 0 ? void 0 : _a.phoneNumber) || ''; }}"
                    :communicationType="${x => { var _a; return ((_a = x.group) === null || _a === void 0 ? void 0 : _a.communicationType) || 'WA'; }}"
                    :agentActive="${x => x.agentActive}"
                    @summary-created="${(x, c) => x.handleSummaryCreated(c.event)}"
                ></comms-messages>
                `)}
                
                
                <div id="summary-list" class="comms-group-list-summaries card">
                    <div class="card-header bg-light py-3">
                        <h5 class="card-title mb-0"><i class="simple-icon-doc mr-2" style="color: #007bff;"></i>${'whatsapp.groups.summaries.title'.t()}</h5>
                    </div>
                    <div class="card-body p-0">
                        ${(0, fast_element_1.when)(x => x.summariesLoading, (0, fast_element_1.html) `
                            <div class="text-center p-3"><app-loader block="true" width="15px" height="15px"></app-loader></div>
                        `)}
                        ${(0, fast_element_1.when)(x => !x.summariesLoading && x.summaries.length === 0, (0, fast_element_1.html) `
                            <p class="text-muted text-center p-4">${'whatsapp.groups.summaries.empty'.t()}</p>
                        `)}
                        ${(0, fast_element_1.when)(x => !x.summariesLoading && x.summaries.length > 0, (0, fast_element_1.html) `
                            <div  id="summary-list-wrap">
                                <table class="table table-striped table-hover mb-0 small">
                                    <thead>
                                        <tr>
                                            <th style="width: 180px;"><i class="simple-icon-calendar mr-1"></i>${'whatsapp.groups.summaries.date'.t()}</th>
                                            <th>${'whatsapp.groups.summaries.excerpt'.t()}</th>
                                            <th class="text-end" style="width: 50px;"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        ${(0, fast_element_1.repeat)(x => x.summaries, (0, fast_element_1.html) `
                                            <tr>
                                                <td class="text-nowrap">${x => x.dateKey}</td>
                                                <td class="text-muted">${(x, c) => c.parent.getSummaryExcerpt(x)}</td>
                                                <td class="text-end">
                                                    <button type="button" class="btn btn-outline-info btn-sm icon-btn"
                                                            @click="${(x, c) => c.parent.showSummary(x)}">
                                                        <i class="simple-icon-eye"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        `)}
                                    </tbody>
                                </table>
                            </div>
                        `)}
                    </div>
                </div>

            </div>
        </div>
    `)}

</div>

${(0, fast_element_1.when)(x => !!x.selectedSummary, (0, fast_element_1.html) `
    <div class="summary-drawer-overlay" @click="${x => x.closeSummaryModal()}"></div>
    <aside class="summary-drawer">
        <div class="p-3 border-bottom d-flex align-items-center justify-content-between">
            <div>
                <h5 class="mb-1 font-weight-bold">${'whatsapp.groups.summaries.modalTitle'.t()}</h5>
                <p class="mb-0 small text-muted">${x => { var _a; return (_a = x.selectedSummary) === null || _a === void 0 ? void 0 : _a.dateKey; }}</p>
            </div>
            <button type="button" class="close" @click="${x => x.closeSummaryModal()}" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="p-3 summary-drawer-body" :innerHTML="${x => { var _a; return (_a = x.selectedSummary) === null || _a === void 0 ? void 0 : _a.summaryText; }}"></div>
    </aside>
`)}
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
}

.whatsapp-group-detail {
  width: 100%;
}
.whatsapp-group-detail .top-right-button-container {
  float: right;
}
.whatsapp-group-detail a.username-link {
  color: var(--primary-color);
  font-weight: 700;
  cursor: pointer;
  text-decoration: underline;
}
.whatsapp-group-detail .member-row .member-tools {
  gap: 10px;
}
.whatsapp-group-detail .member-row.blink {
  animation: blink-animation 0.5s steps(5, start) infinite;
}
.whatsapp-group-detail .member-row.blink td {
  animation: blink-animation 0.5s steps(5, start) infinite;
}

@keyframes blink-animation {
  0% {
    background-color: inherit;
  }
  50% {
    background-color: rgba(253, 253, 21, 0.5);
  }
  100% {
    background-color: inherit;
  }
}
.card {
  padding-top: 1.5rem;
}

.icon-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.summary-drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1040;
}

.summary-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 500px;
  height: 100vh;
  background: #fff;
  box-shadow: -8px 0 28px rgba(0, 0, 0, 0.18);
  z-index: 1050;
  display: flex;
  flex-direction: column;
}
@media (max-width: 767.98px) {
  .summary-drawer {
    width: 100vw;
  }
}

.summary-drawer-body {
  overflow-y: auto;
  flex: 1;
}

#summary-list-wrap {
  max-height: 380px;
  overflow-y: auto;
}

.messages-list {
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.messages-list .message-item:nth-child(odd) {
  background-color: rgb(243, 243, 243) !important;
}

.message-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.message-item:last-child {
  border-bottom: none;
}
.message-item__meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.message-item__sender {
  font-weight: 600;
  font-size: 13px;
  color: #333;
}
.message-item__time {
  font-size: 11px;
  color: #999;
}
.message-item__body {
  font-size: 14px;
  color: #555;
  word-break: break-word;
}`;
const shadowOptions = { "mode": "open" };
let WhatsAppGroupDetail = class WhatsAppGroupDetail extends client_1.RWSViewComponent {
    get allowedPhoneNumbersList() {
        return this.phoneNumbers || [];
    }
    constructor(wsService, waAgentService, clipboardService) {
        super();
        this.wsService = wsService;
        this.waAgentService = waAgentService;
        this.clipboardService = clipboardService;
        this.passedId = '';
        this.remote = false;
        this.phoneNumbers = [];
        this.loading = false;
        this.saving = false;
        this.group = null;
        this.editBotInstruction = '';
        this.editPinMessage = '';
        this.editPinReminderEnabled = false;
        this.editPinReminderIntervalHours = 24;
        this.members = [];
        this.membersLoading = false;
        this.announceMode = false;
        this.announceSaving = false;
        this.promotingMemberId = '';
        this.removingMemberId = '';
        this.summaryText = '';
        this.summaries = [];
        this.summariesLoading = false;
        this.selectedSummary = null;
        this.addingParticipants = false;
        this.participantPhones = [];
        this.newParticipantPhone = '';
        this.agentActive = false;
        this.agentInitializing = false;
        this.agentChecking = false;
        this.editRemoteAccess = false;
        this.editAccessPassword = '';
        this.trackLogs = [];
        this.groupId = '';
        this._agentStatusUnsubscribe = null;
        this._wsUnsubscribers = [];
        this.copiedUrl = false;
    }
    /**
     * Build the public URL for the `whatsapp.groups.view` route.
     * The route is `/api/whatsapp/groups/:id/view` and accepts an optional
     * `phoneNumbers` query parameter (comma-separated).
     */
    getGroupViewUrl() {
        const allowed = this.allowedPhoneNumbersList;
        const query = allowed.length > 0
            ? `?phoneNumbers=${allowed.map(p => encodeURIComponent(p)).join(',')}`
            : `${this.groupId ? `?id=${this.groupId}` : ''}`;
        return `${window.location.origin}/api/whatsapp/gate/view${query}`;
    }
    async copyGroupViewUrl() {
        const url = this.getGroupViewUrl();
        if (!url)
            return;
        const result = await this.clipboardService.copyText(url, {
            successMessage: 'whatsapp.groups.copyUrl.success'.t(),
            errorMessage: 'whatsapp.groups.copyUrl.failed'.t()
        });
        if (result.success) {
            this.copiedUrl = true;
            this.notifyService.notify(result.message || 'whatsapp.groups.copyUrl.success'.t(), 'info');
            setTimeout(() => {
                this.copiedUrl = false;
            }, 2000);
        }
        else {
            this.notifyService.notify(result.message || 'whatsapp.groups.copyUrl.failed'.t(), 'error');
        }
    }
    async connectedCallback() {
        var _a, _b;
        super.connectedCallback();
        this.groupId = ((_a = this.routeParams) === null || _a === void 0 ? void 0 : _a.id) || this.passedId || '';
        if (this.groupId) {
            await this.loadGroup();
            await this.loadMembers();
            await this.loadTrackLogs();
        }
        if ((_b = this.group) === null || _b === void 0 ? void 0 : _b.settingsId) {
            const settingsId = String(this.group.settingsId);
            this._agentStatusUnsubscribe = this.waAgentService.onStatusChange(settingsId, (active, initializing) => {
                this.agentActive = active;
                this.agentInitializing = initializing;
            });
            this.agentChecking = true;
            setTimeout(async () => {
                await this.waAgentService.checkAgentStatus(settingsId);
                const state = this.waAgentService.getPhoneState(settingsId);
                this.agentActive = state.active;
                this.agentInitializing = state.initializing;
                this.agentChecking = false;
            }, 1500);
        }
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            var _a, _b;
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.groupWaId !== ((_a = this.group) === null || _a === void 0 ? void 0 : _a.groupWaId) || (data.settingsId && String(data.settingsId) !== String((_b = this.group) === null || _b === void 0 ? void 0 : _b.settingsId)))
                return;
            this.membersLoading = false;
            if (data.success) {
                this.loadMembers();
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.groups.members.syncFailed'.t(), 'error');
            }
        }, 'comms_sync_members_result'));
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            var _a, _b;
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.groupWaId !== ((_a = this.group) === null || _a === void 0 ? void 0 : _a.groupWaId) || (data.settingsId && String(data.settingsId) !== String((_b = this.group) === null || _b === void 0 ? void 0 : _b.settingsId)))
                return;
            this.promotingMemberId = '';
            if (data.success) {
                this.notifyService.notify('whatsapp.groups.members.promoted'.t(), 'info');
                this.members = this.members.map(m => m.memberId === data.memberId ? { ...m, isAdmin: true } : m);
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.groups.members.promoteFailed'.t(), 'error');
            }
        }, 'comms_promote_member_result'));
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            var _a, _b;
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.groupWaId !== ((_a = this.group) === null || _a === void 0 ? void 0 : _a.groupWaId) || (data.settingsId && String(data.settingsId) !== String((_b = this.group) === null || _b === void 0 ? void 0 : _b.settingsId)))
                return;
            this.removingMemberId = '';
            if (data.success) {
                this.members = this.members.filter(m => m.memberId !== data.memberId);
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.groups.members.removeFailed'.t(), 'error');
            }
        }, 'comms_remove_member_result'));
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            var _a, _b;
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.groupWaId !== ((_a = this.group) === null || _a === void 0 ? void 0 : _a.groupWaId) || (data.settingsId && String(data.settingsId) !== String((_b = this.group) === null || _b === void 0 ? void 0 : _b.settingsId)))
                return;
            this.announceSaving = false;
            if (data.success) {
                this.notifyService.notify('whatsapp.groups.announce.saved'.t(), 'info');
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.groups.announce.failed'.t(), 'error');
            }
        }, 'comms_set_announce_result'));
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            var _a, _b;
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.groupWaId !== ((_a = this.group) === null || _a === void 0 ? void 0 : _a.groupWaId) || (data.settingsId && String(data.settingsId) !== String((_b = this.group) === null || _b === void 0 ? void 0 : _b.settingsId)))
                return;
            this.addingParticipants = false;
            if (data.success) {
                this.participantPhones = [];
                this.newParticipantPhone = '';
                this.notifyService.notify('whatsapp.groups.addParticipants.success'.t(), 'info');
                this.loadMembers();
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.groups.addParticipants.failed'.t(), 'error');
            }
        }, 'comms_add_participants_result'));
        this.addEventListener('track-log-handled', () => {
            this.loadTrackLogs();
        });
        setTimeout(() => {
            var _a;
            (_a = this.mainContainer) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (event) => {
                if (event.target.matches('.username-link')) {
                    this.selectedSummary = null;
                    const targetMember = this.$(`.member-row[data-member="${event.target.dataset.username}"]`);
                    if (targetMember) {
                        targetMember.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        targetMember.classList.add('blink');
                        setTimeout(() => {
                            targetMember.classList.remove('blink');
                        }, 2000);
                    }
                }
            });
        }, 100);
    }
    summaryTextChanged(oldValue, newValue) {
        if (!oldValue && newValue) {
            // Scroll to summary when it's loaded
            setTimeout(() => {
                var _a;
                (_a = this.summaryContainer) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    }
    async loadGroup() {
        var _a, _b, _c;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('whatsapp.groups.get', {
                routeParams: { id: this.groupId }
            });
            if (response && response.success && response.data) {
                this.group = response.data;
                // Enforce phone-number filter on the frontend as well — when the
                // gate passes a list of allowed phone numbers, refuse to render
                // a group whose phone number is not in the list.
                const allowed = this.allowedPhoneNumbersList;
                if (allowed.length > 0 && this.group.phoneNumber && !allowed.includes(this.group.phoneNumber)) {
                    this.group = null;
                    this.notifyService.notify('whatsapp.groups.gate.notAllowed'.t(), 'error');
                    return;
                }
                this.editBotInstruction = this.group.botInstruction || '';
                this.editPinMessage = this.group.pinMessage || '';
                this.editPinReminderEnabled = (_a = this.group.pinReminderEnabled) !== null && _a !== void 0 ? _a : false;
                this.editPinReminderIntervalHours = this.group.pinReminderIntervalHours || 24;
                this.announceMode = (_b = this.group.announce) !== null && _b !== void 0 ? _b : false;
                this.editRemoteAccess = (_c = this.group.remoteAccess) !== null && _c !== void 0 ? _c : false;
                this.editAccessPassword = this.group.accessPassword || '';
                if (this.group.tracking) {
                    await this.loadSummaries();
                }
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.groups.loadFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('whatsapp.groups.loadFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    async loadMembers() {
        this.membersLoading = true;
        try {
            const response = await this.apiService.back.get('whatsapp.groups.members', {
                routeParams: { id: this.groupId }
            });
            if (response && response.success && Array.isArray(response.data)) {
                this.members = response.data;
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.membersLoading = false;
        }
    }
    async syncMembers() {
        if (!this.group)
            return;
        this.membersLoading = true;
        this.wsService.sendMessage('comms_point', 'comms_sync_members', { settingsId: this.group.settingsId, groupWaId: this.group.groupWaId });
    }
    promoteMember(memberId) {
        if (!this.group)
            return;
        this.promotingMemberId = memberId;
        this.wsService.sendMessage('comms_point', 'comms_promote_member', { settingsId: this.group.settingsId, groupWaId: this.group.groupWaId, memberId });
    }
    removeMember(memberId) {
        if (!this.group)
            return;
        this.removingMemberId = memberId;
        this.wsService.sendMessage('comms_point', 'comms_remove_member', { settingsId: this.group.settingsId, groupWaId: this.group.groupWaId, memberId });
    }
    toggleAnnounce(event) {
        if (!this.group)
            return;
        const allUsersCanWrite = event.detail.checked;
        const adminsOnly = !allUsersCanWrite;
        this.announceSaving = true;
        this.wsService.sendMessage('comms_point', 'comms_set_announce', { settingsId: this.group.settingsId, groupWaId: this.group.groupWaId, adminsOnly });
    }
    async toggleTracking(event) {
        if (!this.group)
            return;
        const checked = event.detail.checked;
        this.saving = true;
        try {
            const response = await this.apiService.back.post('whatsapp.groups.setTracking', { tracking: checked }, {
                routeParams: { id: this.groupId }
            });
            if (response && response.success && response.data) {
                this.group = response.data;
                this.notifyService.notify(checked ? 'whatsapp.groups.trackingEnabled'.t() : 'whatsapp.groups.trackingDisabled'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.groups.trackingFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('whatsapp.groups.trackingFailed'.t(), 'error');
        }
        finally {
            this.saving = false;
        }
    }
    handleBotInstructionInput(event) {
        this.editBotInstruction = event.target.value;
    }
    handlePinMessageInput(event) {
        var _a;
        const detail = event.detail;
        this.editPinMessage = (_a = detail === null || detail === void 0 ? void 0 : detail.value) !== null && _a !== void 0 ? _a : event.target.value;
    }
    handlePinReminderToggle(event) {
        this.editPinReminderEnabled = event.detail.checked;
    }
    handlePinReminderIntervalInput(event) {
        var _a;
        const detail = event.detail;
        this.editPinReminderIntervalHours = (_a = detail === null || detail === void 0 ? void 0 : detail.value) !== null && _a !== void 0 ? _a : Number(event.target.value);
    }
    handleRemoteAccessChange(event) {
        this.editRemoteAccess = event.detail.checked;
    }
    handleAccessPasswordInput(event) {
        this.editAccessPassword = event.target.value;
    }
    async saveSecurity() {
        var _a;
        if (!this.group)
            return;
        this.saving = true;
        try {
            const payload = {
                name: this.group.groupName,
                remoteAccess: this.editRemoteAccess,
                accessPassword: this.editAccessPassword
            };
            const response = await this.apiService.back.put('whatsapp.groups.update', payload, { routeParams: { id: this.groupId } });
            if (response && response.success && response.data) {
                this.group = response.data;
                this.editRemoteAccess = (_a = this.group.remoteAccess) !== null && _a !== void 0 ? _a : false;
                this.editAccessPassword = '';
                this.notifyService.notify('whatsapp.groups.security.saved'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.groups.security.failed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('whatsapp.groups.security.failed'.t(), 'error');
        }
        finally {
            this.saving = false;
        }
    }
    async saveSettings() {
        if (!this.group)
            return;
        this.saving = true;
        try {
            const payload = {
                name: this.group.groupName,
                botInstruction: this.editBotInstruction,
                pinMessage: this.editPinMessage,
                pinReminderEnabled: this.editPinReminderEnabled,
                pinReminderIntervalHours: this.editPinReminderIntervalHours,
                invitePhoneNumbers: this.group.invitePhoneNumbers || [],
                remoteAccess: this.editRemoteAccess,
                accessPassword: this.editAccessPassword || undefined
            };
            const response = await this.apiService.back.put('whatsapp.groups.update', payload, { routeParams: { id: this.groupId } });
            if (response && response.success && response.data) {
                this.group = response.data;
                this.editBotInstruction = this.group.botInstruction || '';
                this.notifyService.notify('whatsapp.groups.settingsSaved'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.groups.settingsFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('whatsapp.groups.settingsFailed'.t(), 'error');
        }
        finally {
            this.saving = false;
        }
    }
    handleNewParticipantPhoneInput(event) {
        this.newParticipantPhone = event.target.value;
    }
    addParticipantPhone() {
        const phone = this.newParticipantPhone.trim();
        if (!phone)
            return;
        this.participantPhones = [...this.participantPhones, { id: (0, uuid_1.v4)(), phoneNumber: phone }];
        this.newParticipantPhone = '';
    }
    removeParticipantPhone(entry) {
        this.participantPhones = this.participantPhones.filter(p => p.id !== entry.id);
    }
    async toggleMemberBotSetting(memberId, field, value) {
        try {
            const response = await this.apiService.back.post('whatsapp.groups.updateMember', { [field]: value }, { routeParams: { id: this.groupId, memberId } });
            if (response && response.success) {
                this.members = this.members.map(m => m.id === memberId ? { ...m, [field]: value } : m);
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.groups.members.updateFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('whatsapp.groups.members.updateFailed'.t(), 'error');
        }
    }
    addParticipants() {
        if (!this.group || this.participantPhones.length === 0)
            return;
        this.addingParticipants = true;
        this.wsService.sendMessage('comms_point', 'comms_add_participants', { settingsId: this.group.settingsId, groupWaId: this.group.groupWaId, participants: this.participantPhones.map(p => p.phoneNumber) });
    }
    async loadTrackLogs() {
        var _a;
        if (!this.groupId || !((_a = this.group) === null || _a === void 0 ? void 0 : _a.settingsId))
            return;
        try {
            const response = await this.apiService.back.get('whatsapp.trackLogs.all', {
                routeParams: { settingsId: this.group.settingsId.toString() },
                queryParams: { groupId: this.groupId }
            });
            if (response && response.success && Array.isArray(response.data)) {
                this.trackLogs = response.data;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    onTrackLogHandled() {
        this.loadTrackLogs();
    }
    async loadSummaries() {
        this.summariesLoading = true;
        try {
            const response = await this.apiService.back.get('whatsapp.groups.summaries', {
                routeParams: { id: this.groupId }
            });
            if (response && response.success && Array.isArray(response.data)) {
                this.summaries = response.data;
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.summariesLoading = false;
        }
    }
    showSummary(summary) {
        this.selectedSummary = summary;
    }
    closeSummaryModal() {
        this.selectedSummary = null;
    }
    getSummaryExcerpt(summary) {
        if (!(summary === null || summary === void 0 ? void 0 : summary.summaryText))
            return '';
        const text = summary.summaryText.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        return text.length > 120 ? text.slice(0, 120) + '…' : text;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._wsUnsubscribers.forEach(off => off());
        this._wsUnsubscribers = [];
        if (this._agentStatusUnsubscribe) {
            this._agentStatusUnsubscribe();
            this._agentStatusUnsubscribe = null;
        }
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/settings/comms/' + this.group.settingsId);
    }
    /**
     * Handle summary-created event from comms-messages component.
     * Reloads summaries and shows the newly created one.
     */
    async handleSummaryCreated(event) {
        const detail = event.detail;
        if (!detail)
            return;
        await this.loadSummaries();
        const summary = this.summaries.find(s => s.id === detail.summaryId);
        this.showSummary(summary || null);
    }
};
exports.WhatsAppGroupDetail = WhatsAppGroupDetail;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], WhatsAppGroupDetail.prototype, "passedId", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "remote", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Array)
], WhatsAppGroupDetail.prototype, "phoneNumbers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "saving", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.IWhatsAppGroupData !== "undefined" && backendImport_1.IWhatsAppGroupData) === "function" ? _d : Object)
], WhatsAppGroupDetail.prototype, "group", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppGroupDetail.prototype, "editBotInstruction", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppGroupDetail.prototype, "editPinMessage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "editPinReminderEnabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], WhatsAppGroupDetail.prototype, "editPinReminderIntervalHours", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppGroupDetail.prototype, "members", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "membersLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "announceMode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "announceSaving", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppGroupDetail.prototype, "promotingMemberId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppGroupDetail.prototype, "removingMemberId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppGroupDetail.prototype, "summaryText", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppGroupDetail.prototype, "summaries", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "summariesLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof backendImport_1.IWhatsAppGroupSummaryData !== "undefined" && backendImport_1.IWhatsAppGroupSummaryData) === "function" ? _e : Object)
], WhatsAppGroupDetail.prototype, "selectedSummary", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "addingParticipants", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppGroupDetail.prototype, "participantPhones", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppGroupDetail.prototype, "newParticipantPhone", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "agentActive", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "agentInitializing", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "agentChecking", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "editRemoteAccess", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppGroupDetail.prototype, "editAccessPassword", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppGroupDetail.prototype, "trackLogs", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupDetail.prototype, "copiedUrl", void 0);
exports.WhatsAppGroupDetail = WhatsAppGroupDetail = __decorate([
    (0, client_1.RWSView)('whatsapp-group-detail', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(nest_interconnectors_1.WSService)),
    __param(1, (0, client_1.RWSInject)(WhatsAppAgentService_1.default)),
    __param(2, (0, client_1.RWSInject)(ClipboardService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof nest_interconnectors_1.WSServiceInstance !== "undefined" && nest_interconnectors_1.WSServiceInstance) === "function" ? _a : Object, typeof (_b = typeof WhatsAppAgentService_1.WhatsAppAgentServiceInstance !== "undefined" && WhatsAppAgentService_1.WhatsAppAgentServiceInstance) === "function" ? _b : Object, typeof (_c = typeof ClipboardService_1.ClipboardServiceInstance !== "undefined" && ClipboardService_1.ClipboardServiceInstance) === "function" ? _c : Object])
], WhatsAppGroupDetail);
WhatsAppGroupDetail.defineComponent();
exports.default = WhatsAppGroupDetail;
